import { BrowserRouter, Routes, Route } from "react-router-dom";
import * as Sentry from "@sentry/react";
import AuthProvider from "./hooks/AuthProvider";
import MainLayout from "./layout/MainLayout";
import Home from "./pages/Home";
import SplashScreen from "./pages/SplashScreen";
import Login from "./pages/Login";
import ForgetPassword from "./pages/ForgetPassword";
import axios from 'axios';
import PrivateRoute from "./components/PrivateRoute";
import Profile from "./pages/Profile";
import ResetPassword from "./pages/ResetPassword";
import UnitDetail from "./pages/UnitDetail";
import { StrictMode } from "react";
import ChecklistPage from "./pages/ChecklistPage";
import UnderConstruction from "./pages/UnderConstruction";
import Swal from "sweetalert2";
import StockCheckPage from "./pages/StockCheckPage";
import Units from "./pages/Units";
import UncompletedChecklists from "./pages/UncompletedChecklists";
import { useAutoUpdate } from "./hooks/useAutoUpdate";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.timeout = 15000;

let interceptorInitialized = false;
if (!interceptorInitialized) {
  interceptorInitialized = true;
  axios.interceptors.response.use(
    response => response,
    error => {
      if (error?.response?.status === 401) {
        localStorage.removeItem("token");
      } else if (error?.response?.data?.message) {
        Swal.fire({
          title: 'Error',
          text: error?.response?.data?.message,
          icon: 'error'
        });
      }
      return Promise.reject(error);
    }
  );
}

const SentryRoutes = Sentry.wrapReactRouterRouting(Routes);

function App() {
  useAutoUpdate();

  return (
    <StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <SentryRoutes>
            <Route element={<MainLayout />}>
              <Route path="/" element={<SplashScreen />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgetPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
            </Route>
            <Route element={<PrivateRoute />}>
              <Route path="/home" element={<Home />} />
              <Route path="/units" element={<Units />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/unit/:unitId" element={<UnitDetail />} />
              <Route path="/unit/:unitId/:tab" element={<UnitDetail />} />
              <Route path="/checklist/uncompleted" element={<UncompletedChecklists />} />
              <Route path="/checklist/:checklistId" element={<ChecklistPage />} />
              <Route path="/checklist/:checklistId/question/:questionId" element={<ChecklistPage />} />
              <Route path="/stock-check/:checklistId" element={<StockCheckPage />} />
              <Route path="/settings" element={<UnderConstruction />} />
              <Route path="/notifications" element={<UnderConstruction />} />
            </Route>
          </SentryRoutes>
        </AuthProvider>
      </BrowserRouter>
    </StrictMode>
  );
}

export default App;
